export default {
  name: 'LoadingModal',
  props: { isFetching: false }
};



// WEBPACK FOOTER //
// ./src/components/_modals/loading/loading.js